<template>
<div class="chapter">
<div class="inner_page">
<p class="images1"><img alt="Image" src="images/img3.jpg" style="max-width:100%;"/></p>
<p class="cpy">Copyright © 2016 by Caleb Warnock and Logan J. Lyons</p>
<p class="cpy">All rights reserved.</p>
<p class="cpy">Published by Familius LLC, <a href="http://www.familius.com" target="_blank">www.familius.com</a></p>
<p class="cpy1">Familius books are available at special discounts for bulk purchases for sales promotions or for family or corporate use. Special editions, including personalized covers, excerpts of existing books, or books with corporate logos, can be created in large quantities for special needs. For more information, contact Premium Sales at 559-876-2170 or email <a href="mailto:specialmarkets@familius.com">specialmarkets@familius.com.</a></p>
<p class="cpy1">Library of Congress Catalog-in-Publication Data</p>
<p class="cpy2">2016961879</p>
<p class="cpy2">ISBN 9781944822552</p>
<p class="cpy1">Edited by Maggie Wickes</p>
<p class="cpy2">Cover design by David Miles</p>
<p class="cpy2">Book design by David Miles and Maggie Wickes</p>
<p class="cpy1">10 9 8 7 6 5 4 3 2 1</p>
<p class="cpy2">First Edition</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3b8dbba4